// frontend/src/theme/iparc.js
// 1Parc design tokens — chrome/ink palette. Single source of truth for the dashboard.

export const ink = {
  bg:        '#0D0C0B', // page
  surface:   '#100F0D', // sidebar
  panel:     '#17140F', // card top of gradient
  panel2:    '#131110', // card bottom of gradient
  raised:    '#1B1815', // buttons on panels
  hover:     '#1A1613',
  line:      '#241F1B', // panel borders
  lineSoft:  '#1E1B18', // row dividers
  lineStrong:'#2B2724', // inputs, chrome controls
  lineHi:    '#4E4740',
  text:      '#F4F1EA',
  text2:     '#C9C3B6',
  muted:     '#8F877B',
  muted2:    '#7C7468',
  faint:     '#6E665C',
  faint2:    '#5C554C',
};

export const signal = {
  danger: '#E2574B',
  warn:   '#DFA23C',
  ok:     '#74A98D',
  dangerTint: 'rgba(226,87,75,.13)',
  warnTint:   'rgba(223,162,60,.13)',
  okTint:     'rgba(116,169,141,.13)',
};

// Chrome gradient used by the logo mark and primary buttons
export const chrome = 'linear-gradient(180deg,#F4F1EA,#CFCAC0)';

// Shared Tailwind class strings
export const panelClass =
  'rounded-2xl border border-[#241F1B] bg-gradient-to-b from-[#17140F] to-[#131110]';
export const labelClass =
  'text-[10.5px] uppercase tracking-[.16em] text-[#6E665C]';
export const numClass =
  "font-['Space_Grotesk',sans-serif] tabular-nums";

export const fmt = (n) =>
  Number(n || 0).toLocaleString('fr-FR').replace(/\u202f|\u00a0/g, ' ');
